import type * as api from '@gitbook/api-client';
import { intlPluralizeString } from '@gitbook/react-uikit';
import { confirm, toast } from '@gitbook/spine-react';

import { apiClient } from '../../../state';
import { SiteStructureItemList } from './SiteStructureItemList';

export function addSectionsToGroup(props: {
    sectionGroup: api.SiteSectionGroup;
    siteSections: api.SiteSection[];
    organization: api.Organization;
    site: api.Site;
}) {
    const { sectionGroup, siteSections, organization, site } = props;
    const pluralizedSection = intlPluralizeString({
        count: siteSections.length,
        singular: 'section',
        plural: 'sections',
    });
    void confirm({
        title: `Move ${pluralizedSection} to group "${sectionGroup.title}"?`,
        description: 'Sections in a group are grouped together in site navigation.',
        confirmLabel: 'Move',
        children: <SiteStructureItemList items={siteSections} />,
        onConfirm: async (_event, { preventClose }) => {
            await toast.catch(
                async () => {
                    await Promise.all(
                        siteSections.map((section) =>
                            apiClient.siteSectionGroups.addSectionToGroup(
                                organization.id,
                                site.id,
                                sectionGroup.id,
                                {
                                    sectionId: section.id,
                                }
                            )
                        )
                    );
                    toast.success(`The ${pluralizedSection} have been added to group`);
                },
                `Error while adding ${pluralizedSection} to group`,
                {
                    onReject: preventClose,
                }
            );
        },
    });
}
